export const SITE = "https://preserveearth.co.uk";
export const ORG_ID = `${SITE}/#org`;
export const WEBSITE_ID = `${SITE}/#website`;
export const DEFAULT_OG_IMAGE = `${SITE}/images/og/preserve-earth-share.jpg`;
export const DEFAULT_OG_IMAGE_ALT =
  "Preserve Earth: secure recycling and destruction for UK businesses";

/** Site default share image; leaf routes without their own image spread this into meta. */
export const defaultOgImageMeta = [
  { property: "og:image", content: DEFAULT_OG_IMAGE },
  { property: "og:image:width", content: "1200" },
  { property: "og:image:height", content: "675" },
  { property: "og:image:alt", content: DEFAULT_OG_IMAGE_ALT },
  { name: "twitter:image", content: DEFAULT_OG_IMAGE },
  { name: "twitter:image:alt", content: DEFAULT_OG_IMAGE_ALT },
];

export type Crumb = { name: string; path: string };

/** BreadcrumbList JSON-LD; Home is prepended automatically. Must match the visible <Breadcrumbs>. */
export function breadcrumbScript(crumbs: Crumb[]) {
  const all = [{ name: "Home", path: "/" }, ...crumbs];
  return {
    type: "application/ld+json",
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: all.map((c, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: c.name,
        item: `${SITE}${c.path}`,
      })),
    }),
  };
}
